<template>
  <transition name="fade">
    <div class="sidebar-QRcode">
      <div class="title f-db" target="_blank" v-if="companyMsg">
        <img @click="goCom" :src="companyMsg.logo" class="empty-img" v-if="companyMsg.logo"/>
        <img @click="goCom" src="@assets/img/empty.png" class="empty-img" v-else/>
        <p v-if="companyMsg.name">{{companyMsg.name}}</p>
      </div>
      <div class="code" v-if="url">
        <!-- <div id="qrcode2" class="qrcode"></div> -->
        <img :src="url" />
        <p>微信扫描 查看详情</p>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";

export default {
  name: "sidebar-QRcode",
  props: ["url","showCom",'companyMsg'],
  data() {
    return {
      myqrcode2: null,
      compId: ""
    };
  },
  computed: {
    ...mapGetters({
      exhibitionId:'getExhibitionId'
    }),
  },
  mounted() {
    // this.qrcode(this.url);
    // this.compId = this.$router.history.current.query.compId;
  },
  methods: {
    // qrcode(url) {
    //   this.myqrcode2 = new QRCode("qrcode2", {
    //     width: 200,
    //     height: 200, // 高度
    //     text: url // 二维码内容
    //   });
    // },
    goCom() {
      // this.$router.push(`/ex-details/${this.companyMsg.joinId}?compId=${this.companyMsg.compId}`);
      const url = `${location.origin}/ex-details/${this.companyMsg.joinId}?compId=${this.companyMsg.compId}`;
      window.open(url,"_blank");
    }
  }
};
</script>

<style scoped lang='scss'>
@import "@assets/scss/utils.scss";
.sidebar-QRcode {
  width: 300px;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
  border-radius: 2px;
  background-color: #fff;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
  @include empty-txt(300px, "暂无信息");
  .title {
    min-height: 215px;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 10px;
  }
  .title img {
    width: 96px;
    height: 96px;
    margin-top: 40px;
    border: solid 1px #e6e6e6;
    border-radius: 5px;
    border-radius: 50%;
    cursor: pointer;
  }
  .title p {
    font-size: 18px;
    color: #222;
    margin-top: 20px;
    font-weight: 600;
  }
  .code img {
    margin: 10px auto;
    width: 200px;
    height: 200px;
  }
  .code p {
    font-size: 18px;
    color: #333;
    font-weight: 600;
    padding-bottom: 20px;
  }
  #qrcode2 {
    text-align: center;
    padding: 10px;
  }
}
</style>

<style lang='scss'> 
.sidebar-QRcode { 
  .code img {
    margin: 10px auto !important;
  } 
}
</style>